import { render, staticRenderFns } from "./product_registration.vue?vue&type=template&id=447cdce3&scoped=true&"
import script from "./product_registration.vue?vue&type=script&lang=js&"
export * from "./product_registration.vue?vue&type=script&lang=js&"
import style0 from "./product_registration.vue?vue&type=style&index=0&id=447cdce3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447cdce3",
  null
  
)

export default component.exports